import { FC, useCallback, useState } from 'react';
import { FieldProps, useField } from 'formik';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import styled from 'styled-components';

type TimeZoneFieldProps = FieldProps & {
  offsetName: string;
  className?: string;
};

export const TimeZoneSelect: FC<TimeZoneFieldProps> = ({ field, form, className, offsetName }) => {
  const [, , offsetHelpers] = useField<number>(offsetName);
  const [, , helpers] = useField<number>(field.name);

  const [selectedTimezone, setSelectedTimezone] = useState(field.value);

  const handleChange = useCallback(
    (timezone) => {
      offsetHelpers.setValue(timezone.offset * 60);
      helpers.setValue(timezone.value);

      setSelectedTimezone(timezone);

      form.submitForm();
    },
    [helpers, form, offsetHelpers]
  );

  return (
    <TimezoneSelectWrapper className={className}>
      <TimezoneSelect
        value={selectedTimezone}
        onChange={handleChange}
        timezones={allTimezones}
        menuPortalTarget={document.body}
      />
    </TimezoneSelectWrapper>
  );
};

const TimezoneSelectWrapper = styled.div`
  cursor: pointer;
`;
